import { isFunction, join, type Vector } from "math"
import type { SVGFunctionProps, SVGPathCommand } from "./types"
import { omit } from "../object";
import { processCommands } from "./command";

export const svgCommandPath = (props: SVGFunctionProps & {
  commands: SVGPathCommand[]
}) => {
  const processed = processCommands(props.commands);
  const svgProps = omit(props, ['points', 'commands']) as any;
  return <path {...svgProps} d={processed}   />
}

export const svgPolyLine = (props: SVGFunctionProps & {
  points: Vector[]
}) => {
  const processed = props.points.map(p => p.toString(2, ',')).join(' ');
  const svgProps = omit(props, ['points', 'commands']) as any;
  return <polyline {...svgProps} points={processed}   />
}

export const svgPath = (props: SVGFunctionProps & {
  points: Vector[]
}) => {
  const commands = join(props.points.map(p => p.toString(2, ' ')), {
    prefix: (i) => {
      if (i % 2 === 0) return 'M';
      return 'L';
    },
    suffix: (_i) => null
  }).join(' ');

  const svgProps = omit(props, ['points', 'commands']) as any;

  return <path {...svgProps} d={commands.includes('NaN') ? '' : commands}   />
}


export type SVGCurvePoint = {
  start: Vector;
  end: Vector;
  control: [Vector, Vector];
}

export const svgCurve = (props: SVGFunctionProps & {
  points: SVGCurvePoint[] | (() => SVGCurvePoint[])
}) => {
  const points = isFunction(props.points) ? props.points() : props.points;

  const commands = points.map((curve) => {
    const move = curve.start.toString(2, ' ');
    const end = curve.end.toString(2, ' ');
    const control = curve.control.map(it => it.toString(2, ' ')).join(', ');
    return `M ${move} C ${control}, ${end}`;
  }).join(' ');

  const svgProps = omit(props, ['points']) as any;

  return <path {...svgProps} d={commands}   />
}
